<template>
  <div slot="input">
    <v-row>
      <v-flex>
        <div class="date-as-calendar position-pixels-mobile" @click="handleClick">
          <span class="weekday">{{formatWeekday(values1)}}</span>
          <span class="day">{{formatDay(values1)}}</span>
          <span class="month">{{formatMonth(values1)}}</span>
          <span class="year">{{formatYear(values1)}}</span>
        </div>
        <div :class="{ noShow: isClose }">
          <CalendarDialog language="en" refName="calendarDialog" apply-button-label="apply" :show-helper-buttons="true" :helper-buttons="helperButtons" :switch-button-initial="true" :dateInput="dateInput" :time-input="calendarTimeInput" @on-apply="dateApplied" @select-date="selectD" />
        </div>

        <v-flex>
          <div v-if="this.$vuetify.theme.dark == true">
            <span style="font-size: 20px; color: white; font-family:'Share Tech Mono', monospace;">{{formatTime(values1)}}
              <span class="text-center" style="font-size: 18px; color: white; font-family:'Share Tech Mono', monospace;">{{formatTAmPm(values1)}}
              </span>
            </span>
          </div>
          <div v-else>
            <span style="font-size: 20px; color: black; font-family:'Share Tech Mono', monospace;">{{formatTime(values1)}}
              <span class="text-center" style="font-size: 18px; color: black; font-family:'Share Tech Mono', monospace;">{{formatTAmPm(values1)}}
              </span>
            </span>
          </div>
        </v-flex>

      </v-flex>

      <v-flex style="padding-left:6px; padding-top:15px">
        <v-icon large color="blue-grey">
          mdi-arrow-right-bold
        </v-icon>
      </v-flex>
      <v-flex>
        <div class="date-as-calendar position-pixels-mobile" @click="handleClick">
          <span class="weekday">{{formatWeekday(values2)}}</span>
          <span class="day">{{formatDay(values2)}}</span>
          <span class="month">{{formatMonth(values2)}}</span>
          <span class="year">{{formatYear(values2)}}</span>
        </div>

        <v-flex>
          <div v-if="this.$vuetify.theme.dark == true">
            <span style="font-size: 20px; color: white; font-family:'Share Tech Mono', monospace;">{{formatTime(values2)}}
              <span class="text-center" style="font-size: 18px; color: white; font-family:'Share Tech Mono', monospace;">{{formatTAmPm(values2)}}
              </span>
            </span>
          </div>
          <div v-else>
            <span style="font-size: 20px; color: black; font-family:'Share Tech Mono', monospace;">{{formatTime(values2)}}
              <span class="text-center" style="font-size: 18px; color: black; font-family:'Share Tech Mono', monospace;">{{formatTAmPm(values2)}}
              </span>
            </span>
          </div>
        </v-flex>
      </v-flex>

    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
import { CalendarDialog }  from 'vue-time-date-range-picker/dist/vdprDatePicker';


export default {
  components: {
    CalendarDialog
  },
    props: {
      values1: [Object, String, Date],
      values2: [Object, String, Date],
      updateData: Function,
      isClose: [Boolean, Function],
      dateApplied: Function,
      selectD: Function
    },
    data: () => ({
       dateInput: {
        inputClass: ["dt_picker"],
        format: "DD/MM/YYYY",
      },
      calendarTimeInput: {
        step: 30,
      },
      helperButtons: [
        {
          name: "Last 1 Hour",
          from: moment().subtract(1, "hour"),
          to: moment()
        },
        {
          name: "Last 3 Hour",
          from: moment().subtract(3, "hour"),
          to: moment()
        },
        {
          name: "Last 12 Hour",
          from: moment().subtract(12, "hour"),
          to: moment()
        },
        {
          name: "Today",
          from: moment().startOf("day"),
          to: moment().endOf("day")
        },
        {
          name: "This Week",
          from: moment().clone().startOf("week"),
          to: moment().clone().endOf("week")
        },
        {
          name: "Last Week",
          from: moment().subtract(1, 'weeks').startOf('week'),
          to: moment().subtract(1, "week").endOf("week")
        },
        {
          name: "This Month",
          from: moment().clone().startOf("month"),
          to: moment().clone().endOf("month"),
        },
        {
          name: "Last Month",
          from: moment().subtract(1, "month").startOf("month"),
          to: moment().subtract(1, "month").endOf("month")
        },
      ],
}),
methods: {
   handleClick() {
      this.isClose = !this.isClose;
    },
      formatTime(value) {
      return moment(value).format("h:mm")
      },
      formatTAmPm(value) {
      return moment(value).format("A")
      },
      formatDay(value) {
      return moment(value).format("DD")
      },
      formatYear(value) {
      return moment(value).format("YYYY")
      },
      formatMonth(value) {
      return moment(value).format("MMMM")
      },
      formatWeekday(value) {
      return moment(value).format("dddd")
    },
  }
}
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Source+Code+Pro|Oswald);

/****************************************/
/* Styling rules, such as font and colors */
.date-as-calendar {
  font-variant: normal;
  font-style: normal;
  font-weight: normal;
  font-family: "Helvetica", "Arial", sans-serif;

  /* It seems vertical-align: baseline does not work correctly with display: inline-flex. */
  vertical-align: top;

  /* margin: 1ex; */

  color: black;
  background: white;
  background: linear-gradient(to bottom right, #fff 0%, #eee 100%);

  border: 1px solid #888;
  border-radius: 3px;
  overflow: hidden;

  box-shadow: 2px 2px 2px -2px black;
}
.date-as-calendar .weekday,
.date-as-calendar .day,
.date-as-calendar .month,
.date-as-calendar .year {
  text-align: center;
  line-height: 1;
}
.date-as-calendar .month {
  font-family: "Oswald", sans-serif;
  text-transform: uppercase;
  background: #b11;
  background: linear-gradient(to bottom right, #d66 0%, #a00 100%);
  color: white;
}
/****************************************/
/* Layout rules using position: absolute and pixels. */
/* For Mobile */
.position-pixels-mobile.date-as-calendar {
  display: inline-block;
  position: relative;
  width: 90px;
  height: 75px;
}
.position-pixels-mobile.date-as-calendar .weekday,
.position-pixels-mobile.date-as-calendar .day,
.position-pixels-mobile.date-as-calendar .month,
.position-pixels-mobile.date-as-calendar .year {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 1.4em;
}
.position-pixels-mobile.date-as-calendar .month {
  top: 0px;
  font-size: 13px;
  padding: 2px 0;
}
.position-pixels-mobile.date-as-calendar .weekday {
  top: 20px;
  font-size: 12px;
}
.position-pixels-mobile.date-as-calendar .day {
  top: 32px;
  font-size: 20px;
}
.position-pixels-mobile.date-as-calendar .year {
  top: 54px;
  font-size: 12px;
}
.noShow {
  display: none;
}

@media screen and (max-width: 700px) {
  .vdpr-datepicker__calendar-dialog {
    flex-direction: column;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    width: 85vw !important;
  }

  .vdpr-datepicker__calendar-dialog
    >>> .vdpr-datepicker__calendar-button-helper {
    width: 100%;
    padding: 5px 10px;
    margin: 0 auto;
  }

  .vdpr-datepicker__calendar-dialog >>> .vdpr-datepicker__calendar-actions {
    width: 100% !important;
    padding: 5px 10px;
    font-size: 13px;
  }

  .vdpr-datepicker__calendar-dialog >>> .vdpr-datepicker__calendar {
    width: 100%;
  }
}

.vdpr-datepicker__calendar-dialog >>> .vdpr-datepicker__calendar,
.vdpr-datepicker__calendar-dialog >>> .vdpr-datepicker__calendar-input-wrapper {
  color: black;
}
</style>